// extracted by extract-css-chunks-webpack-plugin
module.exports = {"searchResults":"css-3M-9GuqvjH","searchResults_top":"css-3nN2rysnCY","searchResults_top_term":"css-2aET7bA-Mz","searchResults_top_amount":"css-3gaHAf9C_r"};